import React, { useState, useEffect, useRef } from "react";
import PlusIcon from "../../assets/images/green-plus.svg";
import { Image } from "../componentIndex";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Button } from "common/commonIndex";
import CloseIcon from "../../assets/images/doctorProfile/close-icon.svg";

const UploadFile = ({
    handleUploadFileChange, imgIcon, id,
    buttonName, btnClass, btnType, file, setFile
}) => {
    const [image, setImage] = useState(file || null); // Scoped state per instance
    const [isUploadImg, setIsUploadImg] = useState(false);
    const fileInputRef = useRef(null);
    // Cleanup URLs when unmounting
    useEffect(() => {
        return () => {
            if (image && image instanceof Blob) {
                URL.revokeObjectURL(image);
            }
        };
    }, [image]);

    const handleImageChange = (event) => {
        const file = event?.target?.files[0];
        if (file) {
            // const blobUrl = URL.createObjectURL(file);
            setImage((prevImage) => file);
            handleUploadFileChange(file); // Pass the file up
            setIsUploadImg(true);
        }
    };
    const handleFileCancel = () => {
        setImage((prevImage) => { });
        handleUploadFileChange({}); // Pass the file up
        setIsUploadImg(false);
        if (fileInputRef?.current) {
            fileInputRef.current.value = ""; // ✅ Reset file input field
        }
    }
    return (
        <>
            {image && image?.name && (
                <div className={`upload-file-content mb-3`}>
                    <p className="mb-0 file-name">{image?.name?.split('.')?.[0]}</p>
                    <div onClick={handleFileCancel}>
                        <Image imgUrl={CloseIcon} altText="plus icon" className="icon-24" />
                    </div>
                </div>
            )}
            <div className={`image-upload-container ${file ? 'mb-4' : ''} ${"col-md-6"}`}>
                <input
                    type="file"
                    accept="*"
                    id={`file-input-${id}`}
                    onChange={handleImageChange}
                    aria-label="Upload image"
                    ref={fileInputRef}
                />
                <label htmlFor={`file-input-${id}`}>
                    <div className="upload-button">
                        <div className={btnClass}>
                            {imgIcon && <Image imgUrl={imgIcon} altText="plus icon" className="" />}
                            {buttonName && <p className="mb-0 name">{buttonName}</p>}
                        </div>
                    </div>
                </label>
            </div>
        </>
    );
};

export default UploadFile;
